import {Field} from "./Field";

export class FieldOption {
    constructor({
                    //attributes
                    id= null,
                    field_campaign = null,
                    value= '',
                    field= {},
                    created_at= new Date(),
                    updated_at= new Date()
                    //relations
                } = {}) {

        //fill attributes

        this.id= id;
        this.field_campaign=field_campaign;
        this.value=value;
        this.created_at=created_at;
        this.updated_at=updated_at;

        this.field = new Field(field || {})

    }

}

export function createFieldOption(data={}) {
    return Object.freeze(new FieldOption(data));
}